import { BaseComponent } from "../../../../components/BaseComponent";
import styled from "styled-components";
import Table from "rc-table";
import PropTypes from "prop-types";
import {createStructuredSelector} from "reselect";
import {connect} from "react-redux";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {injectIntl} from "react-intl";
import React from "react";
import { formatCurrency } from "../../../../utils/string";
import { CompanyProductOverviewItemActions } from "./CompanyProductOverviewActions";

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  .rc-table-footer {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 0 16px;
    // margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const IconWrapper = styled.div`
  color: ${props =>
  props?.color === 'darkgray' ? 'darkgray' : 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046'};
`;

class CompanyProductsOverviewTableComp extends BaseComponent {

  getColumns = () => {
    return [
      { title: this.lblStr('product.column.name'), dataIndex: 'name', key: 'name', align: 'left' },
      { title: this.lblStr('product.column.vehicle_purpose'), dataIndex: 'vehiclePurpose', key: 'vehiclePurpose', align: 'left' },
      {
        title: this.lblStr('product.create.purchase_price_excl_vat'),
        dataIndex: 'purchasePriceExclVat',
        key: 'purchasePriceExclVat',
        align: 'left',
        render(value) {
          return value !== null ? formatCurrency(value) : '';
        },
      },
      {
        title: this.lblStr('product.create.sales_price_excl_vat'),
        dataIndex: 'salesPriceExclVat',
        key: 'salesPriceExclVat',
        align: 'left',
        render(value) {
          return value !== null ? formatCurrency(value) : '';
        },
      },
      {
        title: this.lblStr('product.column.actions'),
        key: 'actions',
        dataIndex: 'actions',
        align: 'left',
        render(value) {
          return (
            <ActionsContainer>
              <IconWrapper color={'darkgray'}>
                <CompanyProductOverviewItemActions product={value} />
              </IconWrapper>
            </ActionsContainer>
          );
        },
      },
    ];
  }

  getItems = () => {
    return this.props.products.reduce((list, product) => {
      const productData = {
        name: product.name,
        vatIn: product.vatIn,
        vatOut: product.vatOut
      };
      let group = [];
      product.companyCustomizations.forEach(custom => {
        const item = { ...productData, ...custom, };
        if (!item.vehiclePurpose) item.vehiclePurpose = 'default';
        group.push(this.getData(item));
      });
      group = this.moveDefaultToFront(group);
      list.push(...group);

      return list;
    }, []);
  }

  moveDefaultToFront(arr) {
    const defaultIndex = arr.findIndex(obj => obj.vehiclePurpose === 'default');

    if (defaultIndex > 0) {
      const [defaultObj] = arr.splice(defaultIndex, 1);
      arr.unshift(defaultObj);
    }

    return arr;
  }

  getData = product => {
    const name = product?.name;
    const vehiclePurpose = product.vehiclePurpose;
    const purchasePriceExclVat = product.purchasePriceExclVat;
    const salesPriceExclVat = product.salesPriceExclVat;

    return {
      name,
      vehiclePurpose,
      purchasePriceExclVat,
      salesPriceExclVat,
      id: product.id,
      productId: product.productId,
      actions: product,
      companyId: this.props.companyId,
    };
  };

  render() {
    const columns = this.getColumns();
    const data = this.getItems();
    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText="No products found by current filters"
          onRow={(record, index) => {
            return {
              onClick: () => {
                return this.to(`/companies/${record.companyId}/products/${record.productId}`);
              },
            };
          }}
        />
      </Container>
    );
  }
}

CompanyProductsOverviewTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductsOverviewTable = compose(withConnect, withRouter, injectIntl)(CompanyProductsOverviewTableComp);
